export default __webpack_public_path__ + "85882afee9dabfaa7c8ecc00195f478e.png";